import React from "react";
import { connect } from "react-redux";
import * as actions from "../../actions/actions";
import { FieldError } from "./stripe-split-form";

class CouponInput extends React.Component {
    onChange = e => this.props.stripeCouponCodeChange(e.target.value);
    onApply = e => this.props.stripeCouponCodeCheck();
    render() {
        let label = (
            <FieldError name="Promotional Code" error={this.props.error} />
        );
        return (
            <div className="coupon-field display-flex">
                <input
                    id="coupon"
                    name="coupon"
                    className="optional"
                    type="text"
                    placeholder="Promotional Code"
                    value={this.props.couponCode}
                    onChange={this.onChange}
                />
                {label}
                <div
                    className="button blue apply-coupon"
                    onClick={this.onApply}
                >
                    Apply
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    let { stripe } = state;
    let { fieldErrors, couponCode } = stripe;

    couponCode = couponCode || "";
    let error = fieldErrors && fieldErrors.couponCode;

    return {
        couponCode,
        error
    };
}

CouponInput = connect(
    mapStateToProps,
    {
        stripeCouponCodeCheck: actions.stripeCouponCodeCheck,
        stripeCouponCodeChange: actions.stripeCouponCodeChange
    }
)(CouponInput);

export default CouponInput;
